module.exports = __webpack_public_path__ + "img/fire_elemental_small.8f617863.png";